import { css } from '@linaria/core';

export const wrapperTransparentBackground = css`
	background: unset;
`;
